import { render, staticRenderFns } from "./studenttemstatis.vue?vue&type=template&id=2a07debb&scoped=true"
import script from "./studenttemstatis.vue?vue&type=script&lang=js"
export * from "./studenttemstatis.vue?vue&type=script&lang=js"
import style0 from "./studenttemstatis.vue?vue&type=style&index=0&id=2a07debb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07debb",
  null
  
)

export default component.exports